import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { useDashboardStore } from '../../../store/dashboardStore';
import { GameHeader } from './components/GameHeader';
import { MeasurementDisplay } from './components/MeasurementDisplay';
import { AnswerInput } from './components/AnswerInput';
import { useMeasureGame } from './hooks/useMeasureGame';

export const MeasureMaster: React.FC = () => {
  const navigate = useNavigate();
  const { addPoints } = useDashboardStore();
  const {
    measurement,
    score,
    attempts,
    maxAttempts,
    gameOver,
    showHint,
    timeLeft,
    checkAnswer,
    toggleHint
  } = useMeasureGame();

  const handleGameComplete = () => {
    const timeBonus = Math.floor(timeLeft / 2);
    addPoints(score + timeBonus);
    setTimeout(() => {
      navigate('/dashboard');
    }, 3000);
  };

  useEffect(() => {
    if (gameOver) {
      handleGameComplete();
    }
  }, [gameOver]);

  return (
    <div className="min-h-screen bg-[#4558C8] text-white p-8">
      <GameHeader 
        score={score}
        attempts={attempts}
        maxAttempts={maxAttempts}
        timeLeft={timeLeft}
      />
      
      <div className="max-w-4xl mx-auto space-y-8 mt-8">
        <MeasurementDisplay
          measurement={measurement}
          showHint={showHint}
          onToggleHint={toggleHint}
        />
        
        <AnswerInput 
          onSubmit={checkAnswer}
          unit={measurement.targetUnit}
        />

        {gameOver && (
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            className="fixed inset-0 bg-black/50 flex items-center justify-center"
          >
            <div className="bg-white text-[#4558C8] p-8 rounded-2xl text-center">
              <h2 className="text-4xl font-bold mb-4">Game Over!</h2>
              <p className="text-2xl mb-4">
                {score >= 50 ? 'Measurement Master!' : 'Keep practicing!'}
              </p>
              <p className="text-xl mb-2">Final Score: {score}</p>
              <p className="text-xl mb-4">Time Bonus: {Math.floor(timeLeft / 2)}</p>
              <p className="text-lg">Returning to dashboard...</p>
            </div>
          </motion.div>
        )}
      </div>
    </div>
  );
};